__turbopack_context__.v({
  "container": "CartTicketItemStatus-module-scss-module__XTc7lW__container",
  "pickedUp": "CartTicketItemStatus-module-scss-module__XTc7lW__pickedUp",
  "ready": "CartTicketItemStatus-module-scss-module__XTc7lW__ready",
});
